/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewProcessShort } from './CRSFSecReviewProcessShort';
import {
    CRSFSecReviewProcessShortFromJSON,
    CRSFSecReviewProcessShortFromJSONTyped,
    CRSFSecReviewProcessShortToJSON,
} from './CRSFSecReviewProcessShort';

/**
 * 
 * @export
 * @interface CRSFSecReviewProcessShortPagedResponse
 */
export interface CRSFSecReviewProcessShortPagedResponse {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewProcessShortPagedResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewProcessShortPagedResponse
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewProcessShort>}
     * @memberof CRSFSecReviewProcessShortPagedResponse
     */
    results?: Array<CRSFSecReviewProcessShort>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewProcessShortPagedResponse
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewProcessShortPagedResponse interface.
 */
export function instanceOfCRSFSecReviewProcessShortPagedResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewProcessShortPagedResponseFromJSON(json: any): CRSFSecReviewProcessShortPagedResponse {
    return CRSFSecReviewProcessShortPagedResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewProcessShortPagedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewProcessShortPagedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewProcessShortFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewProcessShortPagedResponseToJSON(value?: CRSFSecReviewProcessShortPagedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewProcessShortToJSON)),
        'total': value.total,
    };
}

